import Card from "components/card";
import React, { useEffect, useRef, useState } from "react";
import InputField from "components/fields/InputField";
import CustomButton from "components/button/custom_button";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ESService } from "services/esService";
import { currentUser } from "services/users/authSlice";
import ApiList from "services/apiList";
import { MdDelete } from "react-icons/md";
import Modal from "components/modal";
import Checkbox from "components/checkbox";
import Select from "components/select";

const ScheduleDetail = () => {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  var user = useSelector(currentUser);
  const [values, setValues] = useState({ name: "" });
  const location = useLocation();
  const [shift, setShift] = useState({});
  const [isActive, setIsActive] = useState(false);
  const [shifts, setShifts] = useState([]);
  const mount = useRef(true);
  const inputs = [
    {
      id: "sch1",
      name: "name",
      type: "text",
      placeholder: "e.g. 2023 оны намарын хичээлийн хуваарь",
      errorMessage: "Хичээлийн хуваарь нэр 1-с дээш тэмдэгтээс бүрдэнэ!",
      label: "Хичээлийн хуваарь нэр",
      pattern: "^.+$",
      required: true,
    },
    {
      id: "sch2",
      name: "start",
      type: "date",
      placeholder: "Эхлэх огноо",
      errorMessage: "Эхлэх огноо оруулна уу",
      label: "Эхлэх огноо",
      required: true,
    },
    {
      id: "sch3",
      name: "end",
      type: "date",
      placeholder: "Дуусах огноо",
      errorMessage: "Дуусах огноо оруулна уу",
      label: "Дуусах огноо",
      required: true,
    },
  ];

  useEffect(() => {
    const getShifts = () => {
      const token = user.token;
      const es = new ESService(token);
      es.get(ApiList.shiftUrl).then((json) => {
        if (json["status"]) {
          setShifts(json["data"]);
        }
      });
    };
    if (mount.current) {
      mount.current = false;
      getShifts();
      if (location.state.type === "edit") {
        setValues(location.state.data);
        setIsActive(location.state.data["is_active"]);
        setShift(location.state.data["shift"]["id"]);
      }
    }
  }, [location.state, user]);
  const onChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    if (!e.preventDefault()) {
      const token = user.token;
      const es = new ESService(token);
      const data = {
        name: values["name"],
        is_active: isActive,
        shift: shift,
        start: values["start"],
        end: values["end"],
      };
      if (location.state.type === "edit") {
        es.put(ApiList.scheduleUrl + values["id"] + "/", data).then((json) => {
          if (json["status"]) {
            navigate("/admin/schedule");
          }
        });
      } else {
        es.post(ApiList.scheduleUrl, data).then((json) => {
          if (json["status"]) {
            navigate("/admin/schedule");
          }
        });
      }
    }
  };

  const handleDelete = (e) => {
    const token = user.token;
    const es = new ESService(token);
    es.delete(ApiList.scheduleUrl + values["id"] + "/", {}).then((json) => {
      if (json["status"]) {
        navigate("/admin/schedule");
      }
    });
  };

  return (
    <Card extra={"mt-4 w-full bg-white p-5"}>
      <header className="relative flex items-center justify-end pt-4 lg:pr-20">
        <button
          className={`rounded-lg bg-lightPrimary p-2 text-brand-500 !transition !duration-200 hover:bg-gray-100 active:bg-gray-200 dark:bg-navy-700 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/10  ${
            location.state.type === "edit" ? "block" : "pt-30 hidden"
          }`}
          onClick={() => setShowModal(true)}
        >
          <MdDelete className="h-6 w-6 fill-red-600" />
        </button>
      </header>
      <div className=" justify-start gap-5 lg:flex lg:px-20 lg:pb-20 ">
        <form onSubmit={handleSubmit}>
          {/* USER INPUTS  */}
          {inputs.map((input) => (
            <InputField
              key={"key" + input.id}
              id={input.id}
              className="lg:w-96"
              {...input}
              value={values[input.name]}
              onChange={onChange}
            />
          ))}
          <div className="mt-4"></div>
          <Checkbox
            label="Ашиглагдаж байгаа эсэх"
            value={isActive}
            onChange={() => setIsActive(!isActive)}
          />
          <Select
            id="shift"
            value={shift}
            required={true}
            label="Ээлж"
            defaultText="Ээлж сонгоно уу."
            onChange={(selected) => {
              setShift(selected.target.value);
            }}
            children={shifts.map((row, index) => {
              return (
                <option key={index} value={row.id}>
                  {row.name}
                </option>
              );
            })}
          />

          <CustomButton text="Хадгалах" type="submit" className="mr-3" />
          <CustomButton
            onClick={() => {
              navigate("/admin/schedule");
            }}
            text="Буцах"
            isBack={true}
          />
        </form>
        {showModal ? (
          <Modal
            handleSubmit={handleDelete}
            setShowModal={setShowModal}
            child={
              <p className="text-xl text-navy-700 dark:text-white">
                Та "{values["name"]}"-ыг устгахдаа итгэлтэй байна уу? Дараахтай
                холбоотой бүх зүйл устаж болзошгүй
              </p>
            }
            title="Устгах"
          />
        ) : null}
      </div>
    </Card>
  );
};

export default ScheduleDetail;
